import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'mtg-linear-progress',
  templateUrl: './linear-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinearProgressComponent {
  @HostBinding('class.linear-progress')
  defaultClass = true;
}
